import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie'

const useSubmitProviderApplication = () => {
    return async (fields, recaptchaToken) => {
        const formData = new FormData();
        const socialList = [];
        const entityList = [];

        formData.set('g_recaptcha', recaptchaToken);

        Object.values(fields).forEach(field => {
            switch (field.name) {
                case 'title':
                    if (true) {
                        formData.set('title', fields.title.value);
                    }
                    break
                case 'country':
                    if (true) {
                        formData.set('country_id', fields.country.value);
                    }
                    break
                case 'industry':
                    if (true) {
                        formData.set('industry_id', fields.industry.value);
                    }
                    break
                case 'logoImage':
                    if (true) {
                        if (fields.logoImage.touched) {
                            formData.set('logo', fields.logoImage.value[0]);
                        }
                    }
                    break
                case 'descriptionShort':
                    if (true) {
                        formData.set('short_description', fields.descriptionShort.value);
                    }
                    break
                case 'descriptionFull':
                    if (true) {
                        if (fields.descriptionFull.touched) {
                            formData.set('full_description', fields.descriptionFull.value);
                        }
                    }
                    break
                case 'emailPublic':
                    if (true) {
                        formData.set('email', fields.emailPublic.value);
                    }
                    break 
                case 'receiveReports':
                    if (true) {
                        formData.set('monthly_reports', fields.receiveReports.value);
                    }
                    break
                case 'phone':
                    if (true) {
                        if (fields.phone.touched) {
                            formData.set('phone', fields.phone.value);
                        }
                    }
                    break
                case 'website':
                    if (true) {
                        if (fields.website.touched) {
                            if (!fields.website.value.startsWith('http')) {
                                formData.set('website', `https://${fields.website.value}`);
                            } else {
                                formData.set('website', fields.website.value);
                            }
                        }
                    }
                    break
                case 'socialFacebook':
                    if (true) {
                        if (fields.socialFacebook.touched) socialList.push({
                            "network": "facebook",
                            "username": fields.socialFacebook.value,
                            "url": `https://facebook.com/${fields.socialFacebook.value}`
                        });
                    }
                    break
                case 'socialInstagram':
                    if (true) {

                        if (fields.socialInstagram.touched) socialList.push({
                            "network": "instagram",
                            "username": '',
                            "url": `https://instagram.com/${fields.socialInstagram.value}`
                        });

                    }
                    break
                case 'socialTwitter':
                    if (true) {
                        if (fields.socialTwitter.touched) socialList.push({
                            "network": "twitter",
                            "username": '',
                            "url": `https://twitter.com/${fields.socialTwitter.value}`
                        });
                    }
                    break
                case 'socialLinkedInProfile':
                    if (true) {
                        if (fields.socialLinkedInProfile.touched) socialList.push({
                            "network": "linkedin",
                            "username": '',
                            "url": `https://www.linkedin.com/${fields.socialLinkedInProfile.value}`
                        });
                    }
                    break
                default:
                    if (true) {
                        if (field.name.startsWith('category-')) {

                           if (field.config.multiSelect) {
                                entityList.push(...field.value);
                            } else {
                                entityList.push(field.value)
                            }
                        }
                    }
                    break
            }
        });

        formData.set('email_for_reports', fields.emailPublic.value);

        formData.set('social_list', socialList.length > 0 ? JSON.stringify(socialList) : 'False');
        if (entityList.length > 0) {
            formData.set('entity_list', entityList);
        }
       
        const additionalHeaders = {}

        const csrfTokenCookie = Cookies.get('csrftoken')

        if (csrfTokenCookie) {
            additionalHeaders['X-CSRFToken'] = csrfTokenCookie
        }

        // document.cookie.split(';').find((val, index) => {
        //     if (val.includes('csrftoken')) {
        //         additionalHeaders['X-CSRFToken'] = val.split('=')[1]
        //     }
        // })
        

        let response;

        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/provider/`,
                {
                    method: 'POST',
                    headers: {
                        'Access-Control-Request-Method': 'POST',
                        ...additionalHeaders
                    },
                    body: formData
                }
            );
        } catch (error) {
            console.log(error);
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 201) {
            const error = new Error();
            switch (response.status) {
                case 400:
                case 415:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.client-bad-request',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    Sentry.captureException(parsedResponse);
                    break;
                default:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.api-bad-response',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    Sentry.captureException(parsedResponse);
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useSubmitProviderApplication;
